import { NavPropertyItem, NavPageItem } from '@common/navdata';
import { IFDDI_WS_Anlagen_Teilverkauf_Daten, RWFPageMap } from '@common/rwf';
import { ValidateNotKendoMobile } from '@common/navkendo';
import { INavPageItemPropertyGroupOptions } from '@rwfangularjs/navkendo';
import { IInfOperation, fn } from '@common/utils';
import { $ModalRequestClose } from '@common/services/DialogService';
import { CompatibilityService } from '../../services/compatibilityservice';
import { TDeferAngularEvent, IDialogState } from '../../services/dialogservice';
import { FDRW_Anordnungsblatt } from '@common/rwf/rwf.const';

const PageNameToTableId : RWFPageMap<number> = {
    "FDRW_Anordnungsblatt" : 5010369,
    "FDDI_DMS_Purchase_Document" : 39,
    "FDDI_DMS_Sales_Document" : 37
}
  /** Show Fixed Asset Part Dispose (Anlagen Teilverkauf) FDRW_Anordnungsblatt/FDRW_SalesDocument */
  export function ShowFAPartDispose(this: void, $c: CompatibilityService, lineItem: NavPropertyItem, notEditable: boolean) {
    var root = lineItem.Root,
        isAo = root.PageName === FDRW_Anordnungsblatt,
        key = <{ [name in keyof IFDDI_WS_Anlagen_Teilverkauf_Daten]?: any }>{
            "Document_Type":  isAo ? 25 : root.GetValue("Document_Type", true),
            "Document_No": lineItem.GetValue(isAo ? "Haushaltsjahr" : "Document_No", true),
            "Line_No": lineItem.GetValue(isAo ? "Zeilennr" : "Line_No", true),
            "Table_ID": PageNameToTableId[root.PageName]
        },
        dlg = $c.resolve("DialogService"),
        client = $c.resolve("NavClient"),
        svc = root.Service,
        pageName = "FDDI_WS_Anlagen_Teilverkauf_Daten";

        if (isAo) {
            fn.ExtendObject<any>(key, {
                Journal_Template_Name : lineItem.GetValue("Erfassungsname", true),
                Journal_Batch_Name: lineItem.GetValue("Gemeindenr", true)
            });
        }
    return client.GetPageClientInfo(pageName, root.ClientInfo).then(clientAnlagen => {
        ValidateNotKendoMobile();
        const getLoadItem = () => client.LoadItem<IFDDI_WS_Anlagen_Teilverkauf_Daten>({ PageName: pageName, Keys: <any>key, NavUrl: root.ClientInfo.Url });
        const methName = "CreateNewAnlagenTeilverkaufDaten";
        return getLoadItem().then((_existingItem) => {
            if (notEditable && !_existingItem) {
                throw new Error('Kein Datensatz vorhanden!');
            }
            if (!_existingItem && lineItem.Root.ClientInfo.RowMethods.indexOf(methName) > 0) {
                return lineItem.Root.ExecuteMethod(<any>{
                    MethodName: methName,
                    RowProperty: lineItem.MetaData.PropertyName,
                    RowKey: lineItem.Model["Key"],
                }, undefined, true).then(() => {
                    return getLoadItem().then(item => {
                        if (!item) {
                            throw new Error(`Auch nach Aufruf von '${methName}' konnte kein Datensatz bestimmt werden!`);
                        }
                        return item;
                    });
                });
            } else {
                return _existingItem || svc.CreateNew<IFDDI_WS_Anlagen_Teilverkauf_Daten>(clientAnlagen, key);
            }
        }).then((showItem: NavPageItem) => {
            const readonlyState = showItem.Anchor.Readonly;
            if (notEditable) {
                readonlyState.SetForceAll(true);
            } else {
                // Custom Disabled/Enabled Handling
                const keys: (keyof IFDDI_WS_Anlagen_Teilverkauf_Daten)[] = [
                    "Partial_Disposal_Amount",
                    "Partial_Disposal_Percent",
                    "Partial_Disposal_Quantity",
                    "Price",
                    "ToAverage"];

                const noSeriesChanged = () => {
                    readonlyState.ReplaceValues("xxx_NoSeries", showItem.GetValue("No_Series") ?  [] : showItem.MetaData.Properties.filter(item => item.Name !== "No_Series"));
                };
                showItem.RegisterPropertyChanged("No_Series", noSeriesChanged);
                noSeriesChanged();

                if (showItem.Root.MetaData.PropsByName["SammelpostenAbgang"]) {
                    readonlyState.RegisterDynamic("SammelpostenAbgang", (item: NavPropertyItem<IFDDI_WS_Anlagen_Teilverkauf_Daten>) => {
                        return keys.filter(key => item.Model[key]).length > 0;
                    });

                    const spaChanged = () => {
                        readonlyState.ReplaceValues("xxx_SammelpostenAbgang", showItem.GetValue("SammelpostenAbgang") === true ? keys : [] );
                    };
                    showItem.RegisterPropertyChanged("SammelpostenAbgang", spaChanged);
                    spaChanged();
                }
            }
          var dlgResult: PromiseLike<IDialogState>,
                cancel = false,
                closeWindow = (asCancel?: boolean) => dlgResult.then(r => { cancel = asCancel; r.window.close(); });
            return dlgResult = dlg.ShowWindow({
                windowOptions: { modal: true, title: "Anlagen Teilverkauf", width: "500px" },
                controller: ['$scope', ($scope: ng.IScope) => {
                    $scope['Item'] = showItem;
                    $scope['propGroupOptions'] = <INavPageItemPropertyGroupOptions>{
                        item: showItem, numCols: 1,
                        view: {
                            ID: "1",
                            Title: "Anlagen Teilverkauf",
                            Properties: showItem.ClientInfo.MetaData.Properties
                                .filter(item => item.Invisible !== true)
                                .map(item => { return { Name: item.Name }; })
                        }
                    };
                    $scope["Delete"] = <IInfOperation>{
                        Execute: () => dlg.WhenConfirm("Wirklich löschen?").then(() =>
                            fn.UISafe(client.Delete(showItem).then(closeWindow.bind(null, false)))),
                        Hidden: "Enabled",
                        Enabled: !showItem.IsNew && !notEditable
                    };
                    $scope["Cancel"] = <IInfOperation>{
                        Caption: notEditable ? "Schließen" : "Abbrechen",
                        Execute: closeWindow.bind(null, true), // () => closeWindow(true);
                        Hidden: "Enabled",
                        Enabled:  !notEditable
                    };
                    $scope["Close"] = <IInfOperation>{
                        Caption: notEditable ? "Schließen" : "Speichern",
                        Execute: () => {
                            $(document.activeElement).blur(); // force commit of pending change
                            return $c.when().then(closeWindow.bind(null, false));
                        }
                    };
                    // Listen to Close Event to Implictly Save if needed
                    $scope.$on($ModalRequestClose, <TDeferAngularEvent>((e, arg) => {
                        if (cancel || notEditable || showItem.IsInSync || showItem.IsDeletedInNav)
                            return;
                        cancel = false;
                        // Prevent Close of window on erroneous update
                        arg.Defer(() => showItem.Update(undefined, true).then(fn.noop,
                            err => dlg.ShowError(fn.resolveToError(err)).then(fn.error.ThrowCancel())));
                    }));
                }],
                template: require('./fapartdispose.html'),
            });
        });
    });
}
